import React from "react";

import type { AuditFieldDiff } from "./auditTypes";
import { humaniseKey } from "./auditFormatters";
import { formatAuditDisplayValue } from "./auditValueDisplay";

type AuditChangesTableProps = {
  changes?: Record<string, AuditFieldDiff> | null;
};

export default function AuditChangesTable({ changes }: AuditChangesTableProps) {
  const entries = Object.entries(changes ?? {});
  if (entries.length === 0) return null;

  return (
    <div className="mt-3 overflow-hidden rounded-xl border border-[#E2E8F0]">
      <table className="min-w-full border-separate border-spacing-0 text-sm">
        <thead>
          <tr>
            <th className="border-b border-[#E2E8F0] bg-[#F6F8FB] px-4 py-2 text-left text-[11px] font-semibold uppercase tracking-[0.08em] text-[#64748B]">
              Field
            </th>
            <th className="border-b border-[#E2E8F0] bg-[#F6F8FB] px-4 py-2 text-left text-[11px] font-semibold uppercase tracking-[0.08em] text-[#64748B]">
              From
            </th>
            <th className="border-b border-[#E2E8F0] bg-[#F6F8FB] px-4 py-2 text-left text-[11px] font-semibold uppercase tracking-[0.08em] text-[#64748B]">
              To
            </th>
          </tr>
        </thead>
        <tbody className="bg-white">
          {entries.map(([key, diff]) => (
            <tr
              key={key}
              className="border-b border-[#E2E8F0]/60 last:border-0"
            >
              <td className="px-4 py-2 font-medium text-[#0F172A]">
                {humaniseKey(key)}
              </td>
              <td className="px-4 py-2 text-[#64748B] line-through decoration-[#94A3B8]">
                {formatAuditDisplayValue(diff?.from)}
              </td>
              <td className="px-4 py-2 font-medium text-[#16A34A]">
                {formatAuditDisplayValue(diff?.to)}
              </td>
            </tr>
          ))}
        </tbody>
      </table>
    </div>
  );
}
